import { render, staticRenderFns } from "./WidgetDashboardButtons.vue?vue&type=template&id=6f397c99&scoped=true"
import script from "./WidgetDashboardButtons.vue?vue&type=script&lang=js"
export * from "./WidgetDashboardButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f397c99",
  null
  
)

export default component.exports